/**
 * Edito Text Seo Manager - Moon Moon Agency
 * Toggle "lire plus / lire moins" sur le texte SEO
 */

/*********************************************************************************************
 * 🔧 EDITO TEXT SEO MANAGER
 */
const EditoTextSeoManager = {
	config: {
		selectors: {
			toggle: '.mm-edito-text-seo-toggle',
			wrapper: '.mm-edito-text-seo-text-wrapper',
			title: 'h2, h1, h3',
		},
		classes: {
			expanded: 'is-expanded',
			noGradient: 'no-gradient',
		},
		scrollOffset: 150,
	},

	init() {
		const toggles = window.getElements(this.config.selectors.toggle);
		if (!toggles.length) return;

		toggles.forEach((toggle) => this._setupToggle(toggle));
		window.log('info', '🔧 [EDITO_TEXT_SEO]', 'Initialized');
	},

	_setupToggle(toggle) {
		const section = toggle.closest('.mm-edito-text-seo');
		const wrapper = toggle.closest('.mm-flex')?.querySelector(this.config.selectors.wrapper);
		if (!wrapper) return;

		const collapsedHeight = parseFloat(getComputedStyle(wrapper).maxHeight);

		const needsToggle = wrapper.scrollHeight > collapsedHeight;
		if (!needsToggle) {
			toggle.style.display = 'none';
			wrapper.classList.add(this.config.classes.noGradient);
			return;
		}

		toggle.addEventListener('click', () => this._toggle(toggle, wrapper, section, collapsedHeight));
	},

	_toggle(toggle, wrapper, section, collapsedHeight) {
		const isExpanded = wrapper.classList.toggle(this.config.classes.expanded);
		toggle.setAttribute('aria-expanded', String(isExpanded));
		toggle.textContent = isExpanded ? toggle.dataset.readLess : toggle.dataset.readMore;

		if (!isExpanded) this._scrollToTitle(section);

		wrapper.style.maxHeight = isExpanded ? `${wrapper.scrollHeight}px` : `${collapsedHeight}px`;

		wrapper.addEventListener('transitionend', () => window.LenisManager?.resize(), { once: true });
	},

	_scrollToTitle(section) {
		const title = section?.querySelector(this.config.selectors.title);
		const target = title || section;
		if (!target) return;

		if (window.LenisManager?.instance) {
			window.LenisManager.scrollTo(target, { offset: -this.config.scrollOffset });
		} else {
			const top = target.getBoundingClientRect().top + window.scrollY - this.config.scrollOffset;
			window.scrollTo({ top, behavior: 'smooth' });
		}
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => EditoTextSeoManager.init());
} else {
	EditoTextSeoManager.init();
}
